<div
    class="sr-app-light:bg-white h-full w-full"
    [ngClass]="{ 'background-image': onboardingLoginFeature.USE_BACKGROUND_IMAGE }">
    <section
        class="mx-4 flex h-full flex-col items-center justify-evenly"
        [ngClass]="{ 'pt-12': onlyPortraitMode$ | async }">
        <div class="flex h-full w-full flex-col items-center justify-evenly" *ngIf="!accessibilityToggle">
            <div class="flex flex-col items-center">
                <img
                    class="pn-app-light-dark:w-8/12"
                    *ngIf="onlyPortraitMode$ | async"
                    alt="{{ 'ONBOARDING_LOGO_ALT' | translate }}"
                    src="{{ assetsPath$ | async }}/img/onboarding/logo.svg" />
                <p class="mt-7 text-lg text-white" *ngIf="!onboardingLoginFeature.USE_OPTIONAL_TEXT">
                    {{ 'ONBOARDING_LOG_IN_TITLE' | translate }}
                </p>
            </div>
            <div class="mt-5 flex flex-col items-center text-center" *ngIf="onboardingLoginFeature.USE_OPTIONAL_TEXT">
                <p
                    class="gl-light:text-[var(--color-primary)] sr-app-light:text-black sr-app-light:text-4xl mt-5 text-2xl font-bold"
                    [ngClass]="{ 'text-white': env.THEME_NAME !== 'varmland' }">
                    {{ 'ONBOARDING_LOG_IN_TITLE' | translate }}
                </p>
                <p
                    class="sr-app-light:text-black mx-8 mt-3 px-8 text-base"
                    [ngClass]="{ 'text-white': env.THEME_NAME !== 'varmland' }">
                    {{ 'ONBOARDING_OPTIONAL_TEXT' | translate }}
                </p>
            </div>
            <div class="flex w-full flex-col items-center">
                <ng-container *ngFor="let action of onboardingLoginFeature.ACTIONS">
                    <ng-container [ngSwitch]="action">
                        <div
                            class="flex w-full flex-col text-center align-middle"
                            *ngSwitchCase="onboardingLoginType.ACCESSIBILITY">
                            <div class="flex w-full flex-row items-center">
                                <ion-item
                                    class="w-full border-t border-solid border-white border-opacity-10"
                                    (click)="openContrastSettings()"
                                    color="light"
                                    button
                                    detail="false">
                                    <ion-icon class="mr-4 text-white" slot="start" name="accessibility"></ion-icon>
                                    <ion-label class="text-base normal-case text-white" color="light">{{
                                        'ONBOARDING_ACCESSIBILITY' | translate
                                    }}</ion-label>
                                </ion-item>
                            </div>
                        </div>
                        <div
                            class="mb-2 flex w-full flex-col text-center align-middle"
                            *ngSwitchCase="onboardingLoginType.HELP">
                            <div class="flex w-full flex-row items-center">
                                <ion-item
                                    class="w-full"
                                    (click)="navigateToFlow('faq', onboardingType.FAQ)"
                                    color="light"
                                    lines="none"
                                    detail="false"
                                    button>
                                    <ion-icon
                                        class="mr-4 text-white"
                                        slot="start"
                                        name="help-circle-outline"></ion-icon>
                                    <ion-label class="text-base normal-case text-white" color="light">{{
                                        'ONBOARDING_HELP' | translate
                                    }}</ion-label>
                                </ion-item>
                            </div>
                        </div>
                        <div
                            class="w-full text-center"
                            *ngSwitchCase="onboardingLoginType.LOGIN"
                            [ngClass]="{ 'my-2': onlyPortraitMode$ | async }">
                            <ion-button
                                class="orb-app-light-dark:py-2 orb-app-light:bg-[var(--color-primary)] gl-light:bg-[var(--color-primary)] vl-app-light:bg-[var(--btn-primary-color)] sr-app-light:bg-[var(--color-secondary)] w-full rounded-lg dark:bg-contrast-yellow dark:text-contrast-black"
                                [attr.aria-label]="'ONBOARDING_LOG_IN' | translate"
                                [ngClass]="env.THEME_NAME === 'varmland' ? 'bg-[var(--color-primary)]' : 'bg-white'"
                                (click)="navigateToFlow('login')"
                                fill="clear"
                                size="large">
                                <ion-label
                                    class="orb-app-light:font-semibold gl-light:text-[var(--color-secondary)] sr-app-light:text-white text-base font-bold normal-case text-black dark:text-contrast-black"
                                    [ngClass]="env.THEME_NAME === 'varmland' ? 'text-white' : ''">
                                    {{ 'ONBOARDING_LOG_IN' | translate }}
                                </ion-label>
                            </ion-button>
                        </div>
                        <div
                            class="w-full text-center"
                            *ngSwitchCase="onboardingLoginType.REGISTER"
                            [ngClass]="{ 'my-2': onlyPortraitMode$ | async }">
                            <ion-button
                                class="mt-4 w-full rounded-lg"
                                [attr.aria-label]="'ONBOARDING_REGISTER' | translate"
                                (click)="navigateToFlow('register')"
                                fill="clear"
                                size="large">
                                <ion-label
                                    class="var-app-light:text-black gl-light:text-[var(--color-primary)] sr-app-light:text-[var(--color-secondary)] flex items-center text-base font-bold normal-case text-white">
                                    <!-- Spacer, could have used ml-6 on ion-label -->
                                    <div
                                        class="w-6"
                                        *ngIf="env.ONBOARDING?.LOGIN?.SHOW_ARROW_AFTER_REGISTER_AND_SKIP"></div>
                                    {{ 'ONBOARDING_REGISTER' | translate }}
                                    <ion-icon
                                        class="h-6 w-6"
                                        *ngIf="env.ONBOARDING?.LOGIN?.SHOW_ARROW_AFTER_REGISTER_AND_SKIP"
                                        aria-hidden="true"
                                        src="{{ assetsPath$ | async }}/img/onboarding/arrow-right-short.svg"></ion-icon>
                                </ion-label>
                            </ion-button>
                        </div>
                        <div
                            class="w-full text-center"
                            *ngSwitchCase="onboardingLoginType.SKIP"
                            [ngClass]="{ 'my-2': onlyPortraitMode$ | async }">
                            <div
                                class="var-app-light:border-black w-full border-t border-solid border-white opacity-10"
                                *ngIf="env.ONBOARDING?.LOGIN?.SHOW_DIVIDER_BETWEEN_REGISTER_AND_SKIP"></div>
                            <ion-button
                                class="gl-light:border-t gl-light:border-white sr-app-light:border-t w-full rounded-lg border-solid !border-opacity-10"
                                [ngClass]="{ 'vl-app-light:mt-4': onlyPortraitMode$ | async }"
                                [attr.aria-label]="'ONBOARDING_SKIP' | translate"
                                (click)="skipLogin()"
                                fill="clear"
                                size="large">
                                <ion-label
                                    class="var-app-light:text-black sr-app-light:text-[var(--color-secondary)] flex items-center text-base font-bold normal-case text-white">
                                    <!-- Spacer, could have used ml-6 on ion-label -->
                                    <div
                                        class="w-6"
                                        *ngIf="env.ONBOARDING?.LOGIN?.SHOW_ARROW_AFTER_REGISTER_AND_SKIP"></div>
                                    {{ 'ONBOARDING_SKIP' | translate }}
                                    <ion-icon
                                        class="h-6 w-6"
                                        *ngIf="env.ONBOARDING?.LOGIN?.SHOW_ARROW_AFTER_REGISTER_AND_SKIP"
                                        aria-hidden="true"
                                        src="{{ assetsPath$ | async }}/img/onboarding/arrow-right-short.svg"></ion-icon>
                                </ion-label>
                            </ion-button>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <div class="flex h-full w-full flex-col items-center justify-evenly" *ngIf="accessibilityToggle">
            <div class="flex w-full flex-col items-center">
                <div class="w-full text-center">
                    <svg
                        class="h-auto w-2/6"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27Z"
                            stroke="white"
                            stroke-width="2"
                            stroke-linejoin="round" />
                        <path
                            d="M16.0098 12.54C17.1143 12.54 18.0098 11.6446 18.0098 10.54C18.0098 9.43547 17.1143 8.54004 16.0098 8.54004C14.9052 8.54004 14.0098 9.43547 14.0098 10.54C14.0098 11.6446 14.9052 12.54 16.0098 12.54Z"
                            fill="white" />
                        <path
                            d="M11.5098 14.54L16.0098 14.83V17.74L13.5098 22.54"
                            stroke="white"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            stroke-linecap="round" />
                        <path
                            d="M20.5098 14.54L16.0098 14.83V17.74L18.4998 22.54"
                            stroke="white"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            stroke-linecap="round" />
                    </svg>
                </div>
                <h1 class="font-bold text-white">{{ 'ONBOARDING_ACCESSIBILITY' | translate }}</h1>
            </div>
            <div class="w-full">
                <ion-list class="mt-3 grow bg-transparent">
                    <ion-radio-group (ionChange)="toggleContrast($event)" value="{{ isContrast }}">
                        <ion-item color="primary">
                            <ion-label class="text-white">{{
                                'ONBOARDING_ACCESSIBILITY_DEFAULT' | translate
                            }}</ion-label>
                            <ion-radio mode="md" slot="start" value="default"></ion-radio>
                        </ion-item>

                        <ion-item color="secondary">
                            <ion-label class="text-white">{{
                                'ONBOARDING_ACCESSIBILITY_HIGH_CONTRAST' | translate
                            }}</ion-label>
                            <ion-radio mode="md" slot="start" value="high-contrast"></ion-radio>
                        </ion-item>
                    </ion-radio-group>
                </ion-list>
            </div>
            <div class="w-full">
                <ion-button
                    class="w-full rounded-lg bg-white dark:bg-contrast-yellow dark:text-contrast-black"
                    [attr.aria-label]="'ONBOARDING_CONFIRM' | translate"
                    (click)="accessibilityToggle = false"
                    fill="clear"
                    size="large">
                    <ion-label class="text-base font-bold normal-case text-black dark:text-contrast-black">
                        {{ 'ONBOARDING_CONFIRM' | translate }}
                    </ion-label>
                </ion-button>
                <ion-button
                    class="mt-4 w-full rounded-lg"
                    [attr.aria-label]="'ONBOARDING_CANCEL' | translate"
                    (click)="cancelContrastChanges()"
                    fill="clear"
                    size="large">
                    <ion-label class="text-base font-bold normal-case text-white">
                        {{ 'ONBOARDING_CANCEL' | translate }}
                    </ion-label>
                </ion-button>
            </div>
        </div>
    </section>
</div>
